<template>
  <v-card class="base-card shadow">
    <v-card-title>
      <strong>Наукометрические показатели</strong>
    </v-card-title>

    <v-card-text class="pb-2">
      <CardFieldRow
        v-model="employee.spin"
        v-mask="'####-####'"
        label="SPIN-код"
        @input="updateEmployee"
      />

      <CardFieldRow
        v-model="employee.author"
        v-mask="'########'"
        label="Автор ID"
        :useVmaskForNumber="true"
        @input="updateEmployee"
      />

      <CardFieldRow
        v-model="employee.orcid"
        v-mask="'XXXX-XXXX-XXXX-XXXX'"
        label="ORCID"
        @input="updateEmployee"
      />

      <CardFieldRow
        v-model="employee.scopusID"
        v-mask="'############'"
        :useVmaskForNumber="true"
        label="Scopus ID"
        @input="updateEmployee"
      />

      <CardFieldRow
        v-model="employee.hirshIndexRsci"
        v-mask="'##'"
        label="Индекс Хирша РИНЦ"
        :useVmaskForNumber="true"
        @input="updateEmployee"
      />

      <CardFieldRow
        v-model="employee.hirshIndexScopus"
        v-mask="'##'"
        label="Индекс Хирша Scopus"
        :useVmaskForNumber="true"
        @input="updateEmployee"
      />

      <CardFieldRow
        v-model="employee.hirshIndexWebOfScience"
        v-mask="'##'"
        label="Индекс Хирша Web of Science"
        hide-border-bottom
        :useVmaskForNumber="true"
        @input="updateEmployee"
      />
    </v-card-text>

    <v-card-actions class="justify-end pr-4 pb-4">
      <v-btn
        class="action-btn"
        height="32"
        color="primary"
        small
        :disabled="isNoChanges"
        :loading="isLoadingSave"
        @click="$emit('save')"
      >
        <v-icon class="uikit-icon save white size-20" />
        <span class="ml-1 btn-text">Сохранить</span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { cloneDeep } from 'lodash'
import { Employee } from '../../models'
import CardFieldRow from '../ui/row/CardFieldRow'

export default {
  name: 'IndicatorsOfScientificActivity',

  props: {
    selectedEmployee: Object,
    isLoadingSave: Boolean,
    isNoChanges: Boolean
  },

  components: {
    CardFieldRow
  },

  data: () => {
    return {
      employee: new Employee()
    }
  },

  validations() {
    return {
      employee: {}
    }
  },

  methods: {
    updateEmployee() {
      this.$emit('updateEmployee', this.employee.getForAPI())
    }
  },

  watch: {
    selectedEmployee: {
      deep: true,
      immediate: true,
      handler(val) {
        this.employee = cloneDeep(val)
      }
    }
  }
}
</script>

<style scoped></style>
